import { EnvironmentProviders, Provider } from '@angular/core';

import { provideUsersDataAccess } from '@efficiently/client-data-access-users';

export const usersProviders: (Provider | EnvironmentProviders)[] = [provideUsersDataAccess()];
